/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerVendorAccountDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCustomerVendorAccountDto, serializeDeleteCustomerVendorAccountRequest, serializeSetCustomerVendorAccountRequest, type CustomerVendorAccountDto, type DeleteCustomerVendorAccountRequest, type ErrorResponse, type InternalErrorResponse, type SetCustomerVendorAccountRequest } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers/{customerNumber}/vendors/{vendorCode}
 */
export interface WithVendorCodeItemRequestBuilder extends BaseRequestBuilder<WithVendorCodeItemRequestBuilder> {
    /**
     * Removes the customer's standing with the vendor. The account stops appearing in listings and reads as 404; setting it again brings it back. Removing an account that does not exist, or was already removed, succeeds quietly with 204, so a retry is safe. The 404 is for an unknown customer or vendor. Admins of an agency organization may remove accounts.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteCustomerVendorAccountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns the customer's standing with one of the agency's vendors: price level, terms, account number at the manufacturer, saved payment method and notes. A customer with no account at the vendor yet, or one whose account was removed, is a 404 — as is an unknown customer or vendor, so the status alone does not say which. Admins and sales reps of an agency organization may read accounts.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerVendorAccountDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithVendorCodeItemRequestBuilderGetQueryParameters> | undefined) : Promise<CustomerVendorAccountDto | undefined>;
    /**
     * Creates or replaces the customer's standing with one of the agency's vendors. There is one account per customer per vendor, so setting it again replaces every field, and setting an account that was removed brings it back. The price level must be one of the vendor's price levels and the terms one of the vendor's terms options, matched ignoring case and stored in the vendor's spelling; leave either out to keep it unset. Admins of an agency organization may set accounts.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerVendorAccountDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: SetCustomerVendorAccountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CustomerVendorAccountDto | undefined>;
    /**
     * Removes the customer's standing with the vendor. The account stops appearing in listings and reads as 404; setting it again brings it back. Removing an account that does not exist, or was already removed, succeeds quietly with 204, so a retry is safe. The 404 is for an unknown customer or vendor. Admins of an agency organization may remove accounts.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteCustomerVendorAccountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns the customer's standing with one of the agency's vendors: price level, terms, account number at the manufacturer, saved payment method and notes. A customer with no account at the vendor yet, or one whose account was removed, is a 404 — as is an unknown customer or vendor, so the status alone does not say which. Admins and sales reps of an agency organization may read accounts.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithVendorCodeItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Creates or replaces the customer's standing with one of the agency's vendors. There is one account per customer per vendor, so setting it again replaces every field, and setting an account that was removed brings it back. The price level must be one of the vendor's price levels and the terms one of the vendor's terms options, matched ignoring case and stored in the vendor's spelling; leave either out to keep it unset. Admins of an agency organization may set accounts.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: SetCustomerVendorAccountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns the customer's standing with one of the agency's vendors: price level, terms, account number at the manufacturer, saved payment method and notes. A customer with no account at the vendor yet, or one whose account was removed, is a 404 — as is an unknown customer or vendor, so the status alone does not say which. Admins and sales reps of an agency organization may read accounts.
 */
export interface WithVendorCodeItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithVendorCodeItemRequestBuilderUriTemplate = "{+baseurl}/api/customers/{customerNumber}/vendors/{vendorCode}{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithVendorCodeItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteCustomerVendorAccountRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerVendorAccountDtoFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerVendorAccountDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSetCustomerVendorAccountRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
